<template>
  <div class="bind-phone-form">
    <a-form layout="vertical">
      <a-form-item label="手机号">
        <a-input
          :value="phone"
          placeholder="请输入手机号"
          :maxlength="11"
          @update:value="emit('update:phone', $event)"
        />
      </a-form-item>

      <a-form-item v-if="showCaptcha" label="图形验证码">
        <div class="captcha-row">
          <a-input
            :value="captchaCode"
            placeholder="请输入4位图形验证码"
            :maxlength="4"
            @update:value="emit('update:captchaCode', $event)"
          />
          <button
            type="button"
            class="captcha-image-btn"
            @click="emit('refreshCaptcha')"
          >
            <img v-if="captchaImage" :src="captchaImage" alt="图形验证码" class="captcha-image" />
            <span v-else>加载中...</span>
          </button>
        </div>
      </a-form-item>

      <a-form-item label="短信验证码">
        <div class="sms-row">
          <a-input
            :value="smsCode"
            placeholder="请输入短信验证码"
            :maxlength="6"
            @update:value="emit('update:smsCode', $event)"
          />
          <a-button :loading="sendingCode" :disabled="!canSendCode" @click="emit('sendSms')">
            {{ smsButtonText }}
          </a-button>
        </div>
      </a-form-item>

      <a-button type="primary" block :loading="submitting" @click="emit('submit')">
        确认绑定
      </a-button>
    </a-form>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  phone: string
  smsCode: string
  captchaCode: string
  captchaImage: string
  showCaptcha: boolean
  canSendCode: boolean
  sendingCode: boolean
  submitting: boolean
  smsButtonText: string
}>()

const emit = defineEmits<{
  'update:phone': [value: string]
  'update:smsCode': [value: string]
  'update:captchaCode': [value: string]
  sendSms: []
  refreshCaptcha: []
  submit: []
}>()
</script>

<style lang="scss" scoped>
.bind-phone-form {
  .captcha-row,
  .sms-row {
    display: flex;
    gap: 12px;
  }

  .captcha-image-btn {
    width: 120px;
    min-width: 120px;
    height: 32px;
    border: 1px solid var(--border-color, #333);
    background: var(--bg-tertiary, #111);
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
    color: var(--text-secondary, #ccc);
  }

  .captcha-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}
</style>
